var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "40px 0 0 20px" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "域名白名单管理", name: "1" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-ruleForm",
                  staticStyle: { width: "60%" },
                  attrs: { "label-width": "150px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "域名白名单", prop: "" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: {
                          placeholder: "请输入",
                          autosize: "",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.domainList,
                          callback: function ($$v) {
                            _vm.domainList = $$v
                          },
                          expression: "domainList",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tips",
                          staticStyle: { color: "rgb(245, 154, 35)" },
                        },
                        [
                          _vm._v(
                            "请在此填写允许调用接口的网站域名(例如:baidu.com)每个域名之间请换行填写"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-top": "60px" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.setList },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }